import { Link } from "react-router-dom";
import { ArrowUpRight, Compass, Ruler, LineChart, Shield, MapPin, Sparkles, Lock, Award, Database, FileCheck2 } from "lucide-react";
import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";

const HERO_IMG = "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MDg0MjIwM3ww&ixlib=rb-4.1.0&q=85";

const BLUEPRINT_IMG = "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBsb29raW5nJTIwYXQlMjBhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50fGVufDB8fHx8MTc5MDg0MjIwM3ww&ixlib=rb-4.1.0&q=85";

export default function Home() {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    api.get("/cities").then((r) => setCities(r.data.slice(0, 10))).catch(() => {});
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#F6F4EE] text-[#0D1F2D]">
      {/* HERO */}
      <section className="border-b border-[#DEDCCF] relative overflow-hidden">
        <div className="blueprint absolute inset-0 pointer-events-none opacity-70" />
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-20 grid lg:grid-cols-12 gap-10 relative">
          <div className="lg:col-span-7 ee-rise">
            <div className="flex items-center gap-2 mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">
              <span className="w-6 h-px bg-[#0D1F2D]" />
              <span>Index · Evaluare imobiliară · RO · 2026</span>
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-[88px] leading-[0.95] tracking-tight font-bold mt-6">
              Evaluare imobiliară <br />
              <span className="italic font-medium">precisă.</span><br />
              Date verificate.
            </h1>
            <p className="mt-8 text-lg text-[#52616B] max-w-xl leading-relaxed">
              Platformă independentă de evaluare pentru proprietăți din România. Modele cantitative
              bazate pe date publice de piață și analiză AI calibrată de evaluatori autorizați.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link
                data-testid="hero-cta-evaluate"
                to="/evaluare"
                className="group bg-[#0D1F2D] hover:bg-[#0F6E5B] transition-colors text-[#F6F4EE] px-7 h-14 rounded-sm font-medium flex items-center gap-2"
              >
                Pornește evaluarea
                <ArrowUpRight size={18} className="group-hover:rotate-45 transition-transform" />
              </Link>
              <Link
                data-testid="hero-cta-zones"
                to="/preturi-zone"
                className="border border-[#0D1F2D] hover:border-[#0F6E5B] hover:text-[#0F6E5B] transition-colors px-7 h-14 rounded-sm font-medium flex items-center gap-2"
              >
                Vezi prețuri pe zone
              </Link>
            </div>

            <div className="mt-14 grid grid-cols-3 max-w-lg">
              {[
                { k: "30s", v: "Timp mediu evaluare" },
                { k: "15+", v: "Orașe acoperite" },
                { k: "AI", v: "Analiză GPT-6 Sol" },
              ].map((s, i) => (
                <div key={i} className="border-r last:border-r-0 border-[#DEDCCF] pr-6">
                  <div className="font-display text-3xl font-bold">{s.k}</div>
                  <div className="mono text-[11px] uppercase tracking-[0.18em] text-[#52616B] mt-1">{s.v}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 relative ee-rise ee-rise-2">
            <div className="relative aspect-[4/5] overflow-hidden border border-[#DEDCCF]">
              <img src={HERO_IMG} alt="Arhitectură modernă" className="w-full h-full object-cover grayscale-[8%]" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D1F2D]/40 via-transparent to-transparent" />
              <div className="absolute left-4 bottom-4 right-4 flex items-end justify-between">
                <div className="text-[#F6F4EE]">
                  <div className="mono text-[10px] uppercase tracking-[0.22em] opacity-80">Index București · Feb 2026</div>
                  <div className="font-display text-3xl font-bold mt-1">2.400 €/m²</div>
                </div>
                <div className="bg-[#0F6E5B] text-white px-3 py-1 mono text-[11px] font-medium">+4.8% YoY</div>
              </div>
            </div>
            {/* Floating card */}
            <div className="absolute -left-6 bottom-8 hidden lg:block bg-white border border-[#DEDCCF] p-5 w-[260px] shadow-[6px_6px_0_0_rgba(26,26,24,0.08)]">
              <div className="mono text-[10px] uppercase tracking-[0.22em] text-[#52616B]">Scenariu demo</div>
              <div className="font-display text-xl font-bold mt-2 leading-tight">Apartament 2 cam · Cluj</div>
              <div className="mt-3 flex items-baseline justify-between">
                <span className="font-display text-2xl font-bold text-[#0F6E5B]">148.500 €</span>
                <span className="mono text-xs text-[#52616B]">55 m²</span>
              </div>
              <div className="mt-3 flex items-center gap-2 text-xs text-[#52616B]">
                <Shield size={12} />
                <span>Încredere 87%</span>
              </div>
            </div>
          </div>
        </div>

        {/* City ticker */}
        <div className="border-t border-[#DEDCCF] bg-[#0D1F2D] text-[#F6F4EE] overflow-hidden">
          <div className="flex whitespace-nowrap ticker py-4">
            {[...cities, ...cities].map((c, i) => (
              <div key={i} className="flex items-center gap-3 px-8 mono text-sm">
                <MapPin size={14} className="text-[#0F6E5B]" />
                <span className="uppercase tracking-[0.18em] text-[11px]">{c.label}</span>
                <span className="text-[#B08D57] font-medium">{fmtEUR(c.avg_eur_sqm)}/m²</span>
                <span className="opacity-40">·</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRUST BAND */}
      <section className="border-b border-[#DEDCCF] bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            { icon: Database, k: "Date de piață", v: "Agregate din listinguri publice, tranzacții notariale și INS" },
            { icon: Award, k: "Partener ANEVAR", v: "Rapoartele oficiale sunt întocmite de evaluatori autorizați" },
            { icon: Lock, k: "Plăți securizate", v: "Procesare prin Stripe · PCI-DSS Level 1 · 3D Secure" },
            { icon: FileCheck2, k: "Conform GDPR", v: "Datele tale nu se partajează. Ștergere la cerere, oricând" },
          ].map((t, i) => (
            <div key={i} className="flex gap-4 items-start">
              <t.icon size={22} strokeWidth={1.6} className="text-[#0F6E5B] shrink-0 mt-1" />
              <div>
                <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#0D1F2D] font-medium">{t.k}</div>
                <div className="text-xs text-[#52616B] mt-1 leading-relaxed">{t.v}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="metodologie" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">§ 02 · Metodologie</div>
            <h2 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-4">
              Date reale.<br />
              Model transparent.<br />
              <span className="italic font-medium text-[#0F6E5B]">Fără magie.</span>
            </h2>
            <p className="mt-5 text-[#52616B] text-base leading-relaxed max-w-sm">
              Evaluăm pe baza prețurilor medii pe m² din 15+ orașe românești, ajustate cu
              factori tehnici și validate de un model AI specializat.
            </p>
          </div>
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-[#DEDCCF] border border-[#DEDCCF]">
            {[
              { icon: Ruler, step: "01", t: "Introduci detalii", d: "Tip, locație, suprafață, cameră, an, stare, dotări. ~30 secunde." },
              { icon: LineChart, step: "02", t: "Calcul deterministic", d: "Preț bază × multiplicatori (tip, stare, an, cameră, dotări)." },
              { icon: Sparkles, step: "03", t: "Analiză AI contextuală", d: "GPT-6 Sol generează raportul calitativ în română." },
              { icon: Shield, step: "04", t: "Rezultat + raport PDF", d: "Interval de preț, scor de încredere, recomandări acționabile." },
            ].map((f, i) => (
              <div key={i} className="bg-[#F6F4EE] p-8 hover:bg-white transition-colors group">
                <div className="flex items-start justify-between">
                  <f.icon size={28} strokeWidth={1.6} className="text-[#0F6E5B]" />
                  <span className="mono text-xs text-[#52616B]">{f.step}</span>
                </div>
                <h3 className="font-display text-xl font-bold mt-5">{f.t}</h3>
                <p className="text-sm text-[#52616B] mt-2 leading-relaxed">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURE BAND */}
      <section className="border-y border-[#DEDCCF] bg-[#0D1F2D] text-[#F6F4EE]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <img src={BLUEPRINT_IMG} alt="Expert evaluator" className="w-full aspect-[5/4] object-cover grayscale" />
          </div>
          <div className="lg:col-span-7">
            <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#0F6E5B]">§ 03 · Pentru cine</div>
            <h2 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-4">
              Un singur instrument. <br />
              Trei scenarii de uz.
            </h2>
            <div className="mt-10 grid gap-5">
              {[
                { t: "Vrei să vinzi?", d: "Setezi un preț de pornire realist, aliniat cu media zonei." },
                { t: "Vrei să cumperi?", d: "Verifici dacă oferta primită este sub, peste sau în linie cu piața." },
                { t: "Ești agent / investitor?", d: "Compari rapid proprietăți, exportezi rapoarte pentru clienți." },
              ].map((x, i) => (
                <div key={i} className="flex gap-6 border-t border-[#F6F4EE]/20 pt-5">
                  <span className="mono text-xs text-[#0F6E5B] mt-1">0{i + 1}</span>
                  <div>
                    <div className="font-display text-xl font-bold">{x.t}</div>
                    <div className="text-sm opacity-70 mt-1">{x.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">§ 04 · Întrebări</div>
            <h2 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-4">Răspunsuri<br />directe.</h2>
          </div>
          <div className="lg:col-span-8 divide-y divide-[#DEDCCF] border-y border-[#DEDCCF]">
            {[
              { q: "Evaluarea este oficială?", a: "Nu. Este o estimare orientativă bazată pe date de piață. Pentru rapoarte acceptate de bănci sau tribunale, îți conectăm cu un evaluator ANEVAR autorizat." },
              { q: "Cât costă?", a: "Evaluarea rapidă este gratuită. Raportul PDF detaliat (comparables, trend, analiză extinsă) costă 19 EUR / proprietate." },
              { q: "Cum sunt protejate datele mele?", a: "Nu stocăm adrese exacte. Emailul se adaugă doar dacă alegi să salvezi evaluarea pentru istoric." },
              { q: "De unde vin datele?", a: "Prețuri medii actualizate pe baza listingurilor publice, tranzacții raportate și statistici INS." },
              { q: "Cât de precisă e estimarea?", a: "Afișăm un scor de încredere (55-95%) în funcție de cât de completă e informația oferită. Mai multe date = interval mai strâns." },
            ].map((f, i) => (
              <details key={i} className="group py-5" data-testid={`faq-${i}`}>
                <summary className="flex items-center justify-between cursor-pointer list-none">
                  <span className="font-display text-xl font-medium">{f.q}</span>
                  <span className="mono text-xs text-[#52616B] group-open:rotate-45 transition-transform">+</span>
                </summary>
                <p className="mt-3 text-[#52616B] text-base leading-relaxed max-w-2xl">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20">
        <div className="border border-[#0D1F2D] bg-[#0F6E5B] text-white p-10 lg:p-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div>
            <div className="mono text-[11px] uppercase tracking-[0.22em] opacity-80">Gata să începi?</div>
            <h3 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-2 max-w-2xl">
              Verifică valoarea proprietății tale în <span className="italic font-medium">30 de secunde</span>.
            </h3>
          </div>
          <Link
            data-testid="final-cta-evaluate"
            to="/evaluare"
            className="bg-[#0D1F2D] text-[#F6F4EE] px-8 h-14 rounded-sm font-medium flex items-center gap-2 hover:bg-black transition-colors shrink-0"
          >
            <Compass size={18} /> Evaluează acum
          </Link>
        </div>
      </section>
    </main>
  );
}
